import {
    ICouponListParams,
    ICouponListResponse,
    ICouponResponse,
    ICreateCouponBody,
    IUpdateCouponBody,
    IRevokeCouponBody,
    IGenerateCouponResponse,
} from "../types/coupons";

import { API_ROUTES } from "@/constants/api-routes";
import AxiosInstance from "@/api";
import { serializeObject } from "@/utils/serializer";

export const GetCoupons = async (params: ICouponListParams, extraQuery?: string) => {
    const queryString = extraQuery ? `${serializeObject(params)}&${extraQuery}` : serializeObject(params);
    const result = await AxiosInstance.get<ICouponListResponse>(`${API_ROUTES.COUPON.LIST}?${queryString}`);
    return result.data;
};

export const GetCouponById = async (id: number) => {
    const result = await AxiosInstance.get<ICouponResponse>(API_ROUTES.COUPON.DETAIL(id));
    return result.data;
};

export const CreateCoupon = async (body: ICreateCouponBody) => {
    const result = await AxiosInstance.post<ICouponResponse>(API_ROUTES.COUPON.CREATE, body);
    return result.data;
};

export const UpdateCoupon = async (id: number, body: IUpdateCouponBody) => {
    const result = await AxiosInstance.put<ICouponResponse>(API_ROUTES.COUPON.UPDATE(id), body);
    return result.data;
};

export const DeleteCoupon = async (id: number) => {
    const result = await AxiosInstance.delete<ICouponResponse>(API_ROUTES.COUPON.DELETE(id));
    return result.data;
};

export const RevokeCoupon = async (id: number, body: IRevokeCouponBody) => {
    const result = await AxiosInstance.put<ICouponResponse>(API_ROUTES.COUPON.REVOKE(id), body);
    return result.data;
};

export const GenerateCouponCode = async (count: number) => {
    const result = await AxiosInstance.get<IGenerateCouponResponse>(API_ROUTES.COUPON.GENERATE(count));
    return result.data;
};

export const DownloadCouponCodes = async (groupId: number) => {
    const result = await AxiosInstance.get(API_ROUTES.COUPON.DOWNLOAD_CODES(groupId), {
        responseType: "blob",
    });
    return result.data;
};

export const ToggleCoupon = async (id: number) => {
    const result = await AxiosInstance.patch(API_ROUTES.COUPON.TOGGLE(id));
    return result.data;
};
